const defaultTextColor = "#22303e";
const positiveColor = "#088752";
const secondaryTextColor = "#65797b";
const headerTextColor = "#007486";
const labelColor = "#56616c";
const sectionBackgroundColor = "#e8eaee";
const linkColor = "#1768c9";
const cardBackgroundColor = "#ebf5fd";
const secondaryCardBackgroundColor = "#F1F4F7";

export {
  defaultTextColor,
  positiveColor,
  secondaryTextColor,
  headerTextColor,
  labelColor,
  sectionBackgroundColor,
  linkColor,
  cardBackgroundColor,
  secondaryCardBackgroundColor,
};
